// Initialize AOS
document.addEventListener('DOMContentLoaded', function() {
    if (typeof AOS !== 'undefined') {
        AOS.init({
            duration: 800,
            easing: 'ease-out-cubic',
            once: true,
            offset: 50
        });
    }

    // Navigation scroll
    var nav = document.getElementById('nav');
    if (nav) {
        window.addEventListener('scroll', function() {
            nav.classList.toggle('scrolled', window.scrollY > 100);
        });
    }

    // Mobile nav toggle
    var navToggle = document.getElementById('navToggle');
    var mobileOverlay = document.getElementById('mobileNavOverlay');
    if (navToggle && mobileOverlay) {
        navToggle.addEventListener('click', function() {
            mobileOverlay.classList.toggle('active');
            document.body.style.overflow = mobileOverlay.classList.contains('active') ? 'hidden' : '';
        });

        // Close mobile nav on link click
        mobileOverlay.querySelectorAll('a').forEach(function(link) {
            link.addEventListener('click', function() {
                mobileOverlay.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }

    // Video toggle
    var heroVideo = document.getElementById('heroVideo');
    var videoIcon = document.getElementById('videoIcon');
    var videoToggle = document.getElementById('videoToggle');
    if (heroVideo && videoToggle && videoIcon) {
        videoToggle.addEventListener('click', function() {
            if (heroVideo.paused) {
                heroVideo.play();
                videoIcon.classList.replace('fa-play', 'fa-pause');
            } else {
                heroVideo.pause();
                videoIcon.classList.replace('fa-pause', 'fa-play');
            }
        });
    }

    // Smooth scroll for hash links (only on same page)
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            var target = document.querySelector(this.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });

    // Counter Animation
    var counters = document.querySelectorAll('.counter');
    var speed = 100;

    function animateCounter(counter) {
        var target = +counter.getAttribute('data-target');
        var increment = target / speed;
        var current = 0;

        function updateCount() {
            current += increment;
            if (current < target) {
                counter.innerText = Math.ceil(current);
                requestAnimationFrame(updateCount);
            } else {
                counter.innerText = target;
            }
        }
        updateCount();
    }

    // Intersection Observer to trigger counters when visible
    if (counters.length > 0) {
        var counterObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    animateCounter(entry.target);
                    counterObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        counters.forEach(function(counter) {
            counterObserver.observe(counter);
        });
    }

    // Product page - variant selector
    var variantSelect = document.getElementById('variantSelect');
    if (variantSelect) {
        variantSelect.addEventListener('change', function() {
            var selectedOption = this.options[this.selectedIndex];
            var price = selectedOption.getAttribute('data-price');
            var priceEl = document.getElementById('productPrice');
            if (priceEl && price) {
                priceEl.textContent = price;
            }
        });
    }

    // Product page - quantity buttons
    var qtyMinus = document.getElementById('qtyMinus');
    var qtyPlus = document.getElementById('qtyPlus');
    var qtyInput = document.getElementById('qtyInput');
    if (qtyMinus && qtyPlus && qtyInput) {
        qtyMinus.addEventListener('click', function() {
            var val = parseInt(qtyInput.value);
            if (val > 1) qtyInput.value = val - 1;
        });
        qtyPlus.addEventListener('click', function() {
            var val = parseInt(qtyInput.value);
            qtyInput.value = val + 1;
        });
    }

    // Product page - thumbnail clicks
    document.querySelectorAll('.product-thumbnails img').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
            var mainImg = document.getElementById('mainProductImage');
            if (mainImg) {
                mainImg.src = this.src.replace('100x100', '800x800').replace('_100x', '_800x');
                // Also try the data-full attribute
                if (this.dataset.full) {
                    mainImg.src = this.dataset.full;
                }
                document.querySelectorAll('.product-thumbnails img').forEach(function(t) {
                    t.classList.remove('active');
                });
                this.classList.add('active');
            }
        });
    });
});
